export function getURL(url, fastboot, logger) {
  if (fastboot.isFastBoot) {
    // You're on the server - no default host
    if (url[0] === '/') {
      let protocol = fastboot.request.protocol;
      if (!protocol) {
        protocol = 'http:';
      }
      let host = '---';
      try {
        host = fastboot.request.host;
      } catch (e) {
        logger.error(`Error getting FastBoot host: ${e}`);
        throw e;
      }
      return `${protocol}//${host}${url}`;
    } else {
      return url;
    }
  } else {
    // in browser
    return url;
  }
}

export function getURLLocale(defaultLocale, fastboot, logger) {
  let path;
  if (fastboot.isFastBoot) {
    // You're on the server - no default host
    try {
      path = fastboot.request.path;
    } catch (e) {
      logger.error(`Error getting FastBoot path: ${e}`);
      throw e;
    }
  } else {
    path = window.location.pathname;
  }

  let pos = path.indexOf('/designtools/');
  if (pos !== -1) {
    let start = pos + '/designtools/'.length;
    let end = start + 2;
    return path.substring(start, end);
  } else {
    return defaultLocale;
  }
}
